<app-page-layout>
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item
            *ngIf="canEdit"
            (click)="openUserEditDialog()">
      <mat-icon>mode_edit</mat-icon>
      <span>Редактировать</span>
    </button>
    <button mat-menu-item
            *ngIf="canResetPassword"
            (click)="openUserResetPasswordDialog()">
      <mat-icon>lock</mat-icon>
      <span>Сбросить пароль</span>
    </button>
    <button mat-menu-item
            *ngIf="canBlock"
            (click)="openUserBlockDialog()">
      <mat-icon>do_not_disturb_on</mat-icon>
      <span>Заблокировать пользователя</span>
    </button>
    <button mat-menu-item
            *ngIf="canUnblock"
            (click)="openUserUnblockDialog()">
      <mat-icon>do_not_disturb_off</mat-icon>
      <span>Разблокировать пользователя</span>
    </button>
    <button mat-menu-item
            *ngIf="canDelete"
            (click)="openUserDeleteDialog()">
      <mat-icon>delete</mat-icon>
      <span>Удалить пользователя</span>
    </button>
  </mat-menu>
  <app-page-bar>
    <app-bar-back-button [link]="['/users']"
                         [tooltip]="'Пользователи'"></app-bar-back-button>
    <app-bar-title>
      <ng-template [ngIf]="!user">Пользователь</ng-template>
      <ng-template [ngIf]="user">{{user.surname}} {{user.name}} {{user.patronymic}}</ng-template>
    </app-bar-title>
    <app-bar-more-button [matMenuTriggerFor]="userMenu"></app-bar-more-button>
  </app-page-bar>
  <app-page-content [narrow]="true">

    <div class="properties" *ngIf="user">
      <div class="property">
        <div class="name">Почта:</div>
        <div class="value">{{user.mail}}</div>
      </div>
      <div class="property">
        <div class="name">Зарегистрирован:</div>
        <div class="value">
          <app-time-event [value]="user.registerDate"></app-time-event>
        </div>
      </div>
      <div class="property">
        <div class="name">Роли:</div>
        <div class="value">{{formatRoles()}}</div>
      </div>
      <div class="property" *ngIf="user.blockDate">
        <div class="name warn">Заблокирован:</div>
        <div class="value">
          <app-time-event [value]="user.blockDate"></app-time-event>
        </div>
      </div>
      <div class="property" *ngIf="user.deleteDate">
        <div class="name warn">Удалён:</div>
        <div class="value">
          <app-time-event [value]="user.deleteDate"></app-time-event>
        </div>
      </div>
    </div>

    <div class="actions">
      <button *ngIf="canEdit"
              mat-raised-button color="primary"
              (click)="openUserEditDialog()">Редактировать
      </button>
      <button *ngIf="canResetPassword"
              mat-raised-button color="primary"
              (click)="openUserResetPasswordDialog()">Сбросить пароль
      </button>
    </div>

  </app-page-content>
</app-page-layout>
